import { render, staticRenderFns } from "./detailUploadFile.vue?vue&type=template&id=54bf3146&scoped=true"
import script from "./detailUploadFile.vue?vue&type=script&lang=js"
export * from "./detailUploadFile.vue?vue&type=script&lang=js"
import style0 from "./detailUploadFile.vue?vue&type=style&index=0&id=54bf3146&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf3146",
  null
  
)

export default component.exports